import { Card, Text, Illustration, LinkButton } from "@certn/cascadia-react";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface EmptyStateProps {
  message: ReactNode;
  button?: ReactNode;
}

export function EmptyState({ message, button }: EmptyStateProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Card>
      <div
        style={{
          display: "flex",
          gap: "var(--space-4)",
          flexDirection: "column",
          alignItems: "center",
          padding: "2rem",
        }}
      >
        <Illustration name="sparkles" />
        {typeof message === "string" ? (
          <Text style="global/body-secondary">{message}</Text>
        ) : (
          message
        )}
        {button ?? (
          <LinkButton
            textStyle="global/body-secondary-link"
            testID="create-new-package"
            onPress={() => navigate(`/packages/create`)}
          >
            {t("Create new package")}
          </LinkButton>
        )}
      </div>
    </Card>
  );
}
